import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { IResponseAPIListado } from "@models/responseAPI.interface";
import { DangerError } from "@shared/errors/custom.error";
import IRegion from "@models/region.interface";
import { SessionService } from "./session.service";
import { environment } from "@env/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { BackendAuthService } from "./backend-auth.service";


@Injectable({
    providedIn: "root",
})
export class RegionService {
    constructor(private httpService: HttpClient, private authService: BackendAuthService, private sessionService: SessionService) {
    }

    async obtenerRegiones(): Promise<IRegion[]> {
        const tokenRes = await this.authService.obtenerToken();
        const token = tokenRes.access_token;
        const url = environment.backendUrl + `/esi-regiones`;
        const body = {};
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'session_id': this.sessionService.getToken() || ''
        });

        const { data, msg, success } =
           await firstValueFrom(this.httpService.post<IResponseAPIListado>(url, body, { headers }));
        console.log(data)
        if (!success || data.length === 0) throw new DangerError(msg);
        return data.map(({ reg_codigo, reg_nombre }) => {
            return {
                codigo: Number(reg_codigo),
                nombre: reg_nombre as string,
                sigla: ""
            }
        })
    }
}